var _defs, _style, _use, _g, _g2, _g3, _path, _g4, _path2, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191 548",
    width: 191,
    height: 548,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 720,
    height: 1280,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtAAAAUAAQMAAABUAPd+AAAAAXNSR0IB2cksfwAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAACISURBVHic7cExAQAAAMKg9U9tDB+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICXAccPAAENzi8BAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.44 38.42h27.06v50.73h-27.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58 0h132.5v79.44h-132.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 39.22h59.01v40.22h-59.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43 533h29.87v15.19h-29.87z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: none;stroke: #117446;stroke-width: 2 } \r\n\t\t.s1 { fill: #117446 } \r\n\t\t.s2 { fill: none;stroke: #2c9263;stroke-width: 2 } \r\n\t\t.s3 { fill: #2c9263 } \r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: -145,
    y: -176
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    style: {
      opacity: 0.7
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_22",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    className: "s0",
    d: "m163.5 38.9l10.7 0.2c2.1 0 4.1 0.5 6 1.3 1.9 0.8 3.7 2 5.1 3.4 1.5 1.5 2.6 3.3 3.4 5.2 0.8 1.9 1.2 3.9 1.2 6l0.1 34.1"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_18",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "s0",
    d: "m58.5 79.4v-24.5c0-2.1 0.4-4.2 1.2-6.1 0.8-1.9 2-3.7 3.5-5.2 1.5-1.5 3.2-2.6 5.2-3.5 1.9-0.8 4-1.2 6.1-1.2h99.5c2.1 0 4.2-0.4 6.1-1.2 2-0.8 3.7-2 5.2-3.5 1.5-1.4 2.7-3.2 3.5-5.1 0.8-2 1.2-4.1 1.2-6.2v-22.9"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_20",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "s0",
    d: "m0 39.7h42.6c2.1 0 4.2 0.4 6.1 1.3 2 0.8 3.7 1.9 5.2 3.4 1.5 1.5 2.6 3.3 3.4 5.2 0.8 2 1.2 4 1.2 6.1v23.7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    className: "s0",
    d: "m58.5 79.4v164.5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    className: "s1",
    d: "m23.5 297.7l4.7-2q0.7-0.3 1.5-0.5 0.8-0.1 1.5-0.1 0.8 0 1.6 0.1 0.8 0.2 1.5 0.5l16.3 6.9q1.2 0.6 2.4 0.9 1.3 0.4 2.5 0.6 1.3 0.2 2.6 0.2 1.3 0 2.6-0.2 0.8 0 1.6-0.2 0.8-0.1 1.5-0.3 0.8-0.2 1.6-0.5 0.7-0.3 1.4-0.6l15.9-6.8q0.7-0.3 1.5-0.5 0.8-0.1 1.6-0.1 0.7 0 1.5 0.1 0.8 0.2 1.5 0.5l4.7 2c0.7 0.3 1.3 0.8 1.8 1.5 0.4 0.7 0.6 1.4 0.6 2.2 0 0.8-0.2 1.6-0.6 2.2-0.5 0.7-1.1 1.2-1.8 1.5l-29.3 12.6q-1.3 0.6-2.8 0.9-1.4 0.3-2.9 0.3-1.5 0-2.9-0.3-1.5-0.3-2.8-0.9l-29.3-12.6c-3.3-1.5-3.3-6.1 0-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    className: "s1",
    d: "m21.7 263.6c-0.4-0.7-0.6-1.5-0.6-2.3 0-0.8 0.2-1.6 0.6-2.2 0.5-0.7 1.1-1.2 1.8-1.5l29.3-12.5q1.3-0.6 2.8-0.9 1.4-0.3 2.9-0.3 1.5 0 2.9 0.3 1.5 0.3 2.8 0.9l29.3 12.6c0.7 0.3 1.3 0.8 1.8 1.5 0.4 0.6 0.6 1.4 0.6 2.2 0 0.8-0.2 1.5-0.6 2.2-0.5 0.7-1.1 1.2-1.8 1.5l-29.3 12.5q-1.3 0.7-2.8 1-1.4 0.3-2.9 0.3-1.5 0-2.9-0.3-1.5-0.3-2.8-1l-29.3-12.5c-0.7-0.3-1.3-0.9-1.8-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    className: "s1",
    d: "m21.7 283.5c-0.4-0.6-0.6-1.4-0.6-2.2 0-0.8 0.2-1.5 0.6-2.2 0.5-0.6 1.1-1.2 1.8-1.5l4.7-2q0.7-0.3 1.5-0.5 0.8-0.1 1.5-0.1 0.8 0 1.6 0.1 0.8 0.2 1.5 0.5l16.3 7q1.2 0.5 2.4 0.8 1.3 0.4 2.5 0.6 1.3 0.2 2.6 0.2 1.3 0 2.6-0.1 0.8-0.1 1.6-0.2 0.8-0.2 1.5-0.4 0.8-0.2 1.6-0.5 0.7-0.2 1.4-0.6l15.9-6.8q0.7-0.3 1.5-0.5 0.8-0.1 1.6-0.1 0.7 0 1.5 0.1 0.8 0.2 1.5 0.5l4.7 2c0.7 0.3 1.3 0.9 1.8 1.5 0.4 0.7 0.6 1.4 0.6 2.2 0 0.8-0.2 1.6-0.6 2.2-0.5 0.7-1.1 1.2-1.8 1.5l-29.3 12.6q-1.3 0.6-2.8 0.9-1.4 0.3-2.9 0.3-1.5 0-2.9-0.3-1.5-0.3-2.8-0.9l-29.3-12.6c-0.7-0.3-1.3-0.8-1.8-1.5z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    className: "s2",
    d: "m58 316v218.4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_27",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    className: "s3",
    d: "m72.9 548.2c0 0-7.5 0-15 0-7.4 0-14.9 0-14.9 0 10.3-4.8 14.9-15.2 14.9-15.2 0 0 4.6 10.4 15 15.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXx);
export default __webpack_public_path__ + "static/media/xx.e0b5d9117e97cd469bf40017fec07df0.svg";
export { ForwardRef as ReactComponent };